import {AbstractHandler} from "./AbstractHandler";

export class VK extends AbstractHandler {
    execute(url) {
        window.open(
            `https://vk.com/share.php?url=${encodeURIComponent(url)}`,
            "sharer",
            "toolbar=0,status=0,width=626,height=436"
        );
    }
}
